import React, {Component} from 'react'
import {Link} from 'react-router'
import DustMitePhoto from '../../images/dust_mite.jpg'
import DrainFlyPhoto from '../../images/Drain_Fly.jpg'
import DenguefeverPhoto from '../../images/Denguefever.jpg'

const Jeyu = {
  aBox: {
   display: 'block',
   paddingBottom: 15,
   boxShadow: '0 0 7px rgba(0,0,0,.2)',
   borderRadius: 7
 },
  h1: {
   textAlign: 'left',
   fontSize: 20,
   fontWeight: 400,
   padding: 0,
   margin: 0,
   textOverflow: 'ellipsis',
   whiteSpace: 'nowrap',
   overflow: 'hidden',
   width: '100%',
   color: '#014852'
 },
 a: {
   color: '#014852'
 },
 p: {
   color: 'rgb(85,85,85)',
   minHeight: 77
 },
 photoBox1: {
  height: 120,
  background: 'url('+DustMitePhoto+')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat'
 },
 photoBox2: {
  height: 120,
  background: 'url('+DrainFlyPhoto+')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat'
 },
 photoBox3: {
  height: 120,
  background: 'url('+DenguefeverPhoto+')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat'
 },
 hasPadding: {
   padding: 20
 }
}

class ListDustMite extends Component {
  render() {
    return(
      <Link to="/Dust_Mite" style={Jeyu.aBox}>
       <div style={Jeyu.photoBox1}></div>
       <div style={Jeyu.hasPadding}>
        <h1 style={Jeyu.h1}>塵瞞!全世界兩千萬人過敏元凶</h1>
        <p style={Jeyu.p}>科學家確定塵蹣為室內過敏症的罪魁禍首塵蹣是灰塵中引起過敏的主因</p>
        <time datetime="2017-04-20 13:30" style={Jeyu.p}>Apr 20, 2017 by JeyuTex</time>
       </div>
      </Link>
    )
  }
}
class ListDrainFly extends Component {
  render() {
    return(
      <Link to="/Drain_Fly" style={Jeyu.aBox}>
       <div style={Jeyu.photoBox2}></div>
       <div style={Jeyu.hasPadding}>
        <h1 style={Jeyu.h1}>不能輕忽的騷擾性害蟲:蛾蚋!</h1>
        <p style={Jeyu.p}>蛾蚋蟲體死後風化分解混入塵埃，如果被特異體質的人呼吸吸入也會引起氣管過敏、哮喘等過敏症。</p>
        <time datetime="2017-04-20 13:30" style={Jeyu.p}>Apr 22, 2017 by JeyuTex</time>
       </div>
      </Link>
    )
  }
}
class ListDengueFever extends Component {
  render() {
    return(
      <Link to="/Dengue_Fever" style={Jeyu.aBox}>
       <div style={Jeyu.photoBox3}></div>
       <div style={Jeyu.hasPadding}>
        <h1 style={Jeyu.h1}>可怕的急性傳染病:登革熱!</h1>
        <p style={Jeyu.p}>認識登革熱的相關知識,才能有效的制止登革熱生長</p>
        <time datetime="2017-04-20 13:30" style={Jeyu.p}>Apr 24, 2017 by JeyuTex</time>
       </div>
      </Link>
    )
  }
}

export default class BlogList extends Component {
  render() {
    return(
      <div className="container">
       <div className="row">
        <div className="xs-12 sm-6 md-4 lg-4">
         <ListDustMite />
        </div>
        <div className="xs-12 sm-6 md-4 lg-4">
         <ListDrainFly />
        </div>
        <div className="xs-12 sm-6 md-4 lg-4">
         <ListDengueFever />
        </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/BlogList.js